import React from "react";
import { Icon } from "./Icon";
import { WebVideoArt } from "./WebVideoArt";
import { WebVideo } from "./WebVideoCard";
import { videoMinutes } from "../formatDuration";

type Props = {
  video: WebVideo;
  onPlay: (v: WebVideo) => void;
  eyebrow?: string;
};

// A wide, landscape "spotlight" card — distinct from the standard portrait
// WebVideoCard. Big 16:9 category-gradient art with the title + meta + a pill
// Watch button overlaid. We intentionally DON'T render the poster image here:
// the seeded SVG posters bake the title into the artwork, which collides with
// our overlaid title. The gradient art carries no text, so the overlay stays
// crisp and never double-prints the title.
export function WebSpotlightCard({ video, onPlay, eyebrow }: Props) {
  const minutes = videoMinutes(video.duration ?? 360);
  const ageLabel =
    video.ageMin && video.ageMax ? `${video.ageMin}–${video.ageMax}` : "3–6";

  return (
    <button
      className="w-spotlight"
      onClick={() => onPlay(video)}
      style={{ width: "100%", minWidth: 0, maxWidth: "100%" }}
    >
      <div className="w-spotlight-art">
        <WebVideoArt category={video.category} />
        {/* Bottom-up scrim so the white text stays legible over the art. */}
        <div className="w-spotlight-scrim" />
        {video.isPremium && (
          <div className="lock-badge" style={{ zIndex: 3 }}>
            <Icon name="lock" size={14} />
          </div>
        )}
        <div className="w-spotlight-body">
          {eyebrow && <div className="w-spotlight-eyebrow">{eyebrow}</div>}
          <div className="w-spotlight-title">{video.title}</div>
          <div className="w-spotlight-sub">
            <span>{video.category || "Video"}</span>
            <span className="dot" />
            <span>{minutes} min</span>
            <span className="dot" />
            <span>Age {ageLabel}</span>
          </div>
          <span className="w-spotlight-play">
            <Icon name="play" size={14} /> Watch now
          </span>
        </div>
      </div>
    </button>
  );
}

export default WebSpotlightCard;
